var exports = {
  "kL": "Tabs.module__container___cUc5ek",
  "Mf": "Tabs.module__tab___cUc5ek",
  "wH": "Tabs.module__selected___cUc5ek",
};

module.exports = exports;
